import React, { useState, forwardRef } from "react";

import { InputText } from "primereact/inputtext";
import MeaCreateModal from "../../../../components/MeaCreateModal";
import { InputTextarea } from "primereact/inputtextarea";
import documentsAPI from "../../../../services/documents";

const CreateFolderModal = forwardRef((props, ref) => {
  //
  const [name, setName] = useState("");
  const [presentation, setPresentation] = useState("");
  //
  return (
    <>
      <MeaCreateModal
        ref={ref}
        title="Créer un dossier"
        schoolId={props.schoolId}
        trainingId={props.trainingId}
        serviceAPI={documentsAPI}
        data={{
          name: name,
          presentation: presentation,
          is_folder: true,
          parent_id: props?.parentId,
        }}
        onSubmitted={() => {
          setName("");
          setPresentation("");
        }}
      >

        <InputText
          id="name"
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="w-full mb-3"
          autoFocus
        />


      </MeaCreateModal>
    </>
  );
});

export default CreateFolderModal;
